<template>
	<div :class="{disable: loading || disabled}" class="ai-button">
		<AppButton outline :text="text" icon-left="icon-ai-warn-red" :disabled="disabled" :loading="loading" />
	</div>
</template>

<script>
import AppButton from "@/shared/components/AppButton.vue";
import {useSvgStore} from "@/shared/stores";

export default {
	setup() {
		const svgStore = useSvgStore();
		return {getIcon: svgStore.get};
	},
	name: "AiButton",
	components: {AppButton},
	props: {
		disabled: {type: Boolean, default: false},
		loading: {type: Boolean, default: false},
		text: {type: String, default: ''},
	},
}
</script>
<style lang="scss" scoped>
.ai-button {
	transition: border-radius .2s $transition, box-shadow .3s $transition, filter .3s $transition, background-color .3s $transition, color .3s $transition, border .3s $transition;
	width: -webkit-fit-content;
	width: -moz-fit-content;
	width: fit-content;
	position: relative;
	color: #fff;
	background: #8f4dfe0d;
	border: none;
	border-radius: 13px;
	cursor: pointer;
	z-index: 0;
	padding: 2px 0;

	&:hover {
		box-shadow: var(--color-shadow-button) 3px 3px 8px 1px, var(--color-light-shadow-button) -3px -3px 10px 2px;
		filter: brightness(1.05);
	}

	&:active {
		border-radius: 15px;
		box-shadow: var(--color-shadow-button) 3px 3px 8px 1px, var(--color-light-shadow-button) -3px -3px 10px 2px;
	}

	&, & * {
		@include noSelect();
	}

	&.disable {
		padding: 1px;
		border-radius: 14px;
	}

	&::before{
		content: "";
		position: absolute;
		inset: 0;
		padding: 1px;
		border-radius: inherit;
		--angle:160deg;
		background: linear-gradient(var(--angle),var(--color-secondary) 0%,#E3216B 27%,#8F4DFE 63%,var(--color-primary) 100%);
		z-index: -1;
		-webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
		-webkit-mask-composite: xor;
		mask-composite: exclude;
		pointer-events: none;
	}

	.base-button.outline {

		padding: 5px 16px;
		pointer-events: none;
		border-color: transparent;
		:deep(.btn-text) {
			p {
				color: var(--color-txt);
			}
		}
		&.disabled-btn:deep(.btn-text) {
			p {
				color: var(--color-txt-2);
			}
		}
		:deep(.button-icon) {
			max-width: 55px;
			img {
				max-width: 22px;
				max-height: 22px;
				width: 22px;
			}
		}

	}
}
</style>